import { dayjs } from '../../support/helpers/dayjs.ts';
import { useInstance } from '../../support/ioc/useInstance';
import { Device } from '../../support/Device.ts';
import { IonInput } from '@ionic/react';
import { PickerWrapper } from '../picker/PickerWrapper.tsx';
import { DateTimePicker } from '../picker/DateTimePicker.tsx';
import { FieldInputProps } from './Field.tsx';

export interface TimeInputProps extends FieldInputProps {
    value: string;
    onChange?: (value: string) => void;
}

export const TimeInput: React.FC<TimeInputProps> = ({ readonly, value, onChange }) => {
    const device = useInstance(Device);

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const handleChange = (dateTime: string) => {
        if (onChange && !readonly) {
            onChange(dayjs(dateTime).toISOString());
        }
    };

    const iosStyle = { marginTop: 5, marginBottom: -2 };
    const androidStyle = { marginTop: 4, marginBottom: -8 };
    const style = device.mode === 'ios' ? iosStyle : androidStyle;

    return (
        <div style={style}>

            {/* dummy IonInput value forces Field wrapper label to be stacked */}
            <IonInput value="dummy" style={{display: 'none'}}/>

            <PickerWrapper>
                <DateTimePicker disabled={readonly} dateTime={value} timezone={timezone} onChange={handleChange} />
            </PickerWrapper>

        </div>
    );
};
